module.exports = __webpack_public_path__ + "img/illustration-step-3-03.0ab330e2.svg";